export const Translations_SK = {
	footer: {
		join: "Pripojte sa k diskusii. Netreba aplikáciu ani prihlásenie.",
		climate: "Pozitívna diskusia o klíme.",
		tree: "Tento strom bol zasadený.",
		start: "Začnite video diskusiu zadarmo.",
	},
};
